<template>
  <!-- -->
  <div class="table-data-4-setting mini-component">
    <div class="desc">
      固定上传三张图片，每一张图片需要的尺寸都是固定的。
    </div>
    <div v-if="showList">
      <div v-for="(item, idx) in imageList" :key="idx" @click="toSetting(item, idx)" class="image-card">
        <alone-image-setting :data="item"/>
      </div>
    </div>
    <div v-else>
      <page-button @click="showList = true">返回</page-button>
      <alone-data v-model="currentData" @change="changeData" :show-tag="false" :show-background="false" :show-icon="false"/>
    </div>

  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import AloneImageSetting from "@/views/h5/common/sys/miniProgram/setting/component/AloneImageSetting.vue";
export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneData, AloneImageSetting
  },
  data() {
    return {
      showList: true,
      currentData: {},
      currentIndex: 0,
      imageList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "250*250"},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "380*115"},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: "380*115"},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    },
    // 设置
    toSetting(data, idx) {
      this.currentIndex = idx;
      this.currentData = data;
      this.showList = false;
    },
    // 数据变更
    changeData() {
      this.imageList[this.currentIndex] = this.currentData;
      // 将数据向上级提交
      this.$emit("change", {
        ...this.data,
        componentData: this.imageList
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-data-4-setting {
  .image-card {
    margin-top: 10px;
  }
}
</style>